exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".in-progress {\n  display: flex;\n  height: 100%;\n  flex-grow: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-around;\n  padding: 3rem 0 0;\n}\n\n.in-progress svg {\n  width: 23rem;\n  height: 23rem;\n}\n\n.in-progress h1 {\n  font-size: 5rem;\n  text-align: center;\n}\n\n.in-progress h2 {\n  font-size: 4.4rem;\n  white-space: pre-wrap;\n}\n\n.in-progress h3 {\n  font-size: 3.1rem;\n  text-align: center;\n  color: #0d3a52;\n  white-space: pre-wrap;\n}\n\n.in-progress span {\n  color: #4FC3F1;\n}\n\n", ""]);

// exports
